/* 🤖 this file was generated by svg-to-ts */
export const matIconRamenDining: {
  name: 'ramen-dining';
  data: string;
} = {
  name: 'ramen-dining',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.66 14c-.66 1.92-2.24 3.54-4.4 4.39l-1.26.5V20h-4v-1.11l-1.27-.5c-2.16-.85-3.74-2.47-4.4-4.39h15.33M22 2 4 3.99V12H2c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25H10.5V8H22V6.5H10.5V4.78L22 3.51V2zM8 6.5V5.06l1-.11V6.5H8zm-2.5 0V5.34l1-.11V6.5h-1zM8 12V8h1v4H8zm-2.5 0V8h1v4h-1z"/></svg>`
};
